import { stores } from '@kurtosys/app-start';
import { components } from '@kurtosys/ksys-app-components';
import { IManifest } from '@kurtosys/types/appsManager/index.js';
import { action, computed, makeObservable, observable } from 'mobx';

import { IComponentStyles } from '../../../models/app/IComponentStyles.js';
import { IConfiguration } from '../../../models/app/IConfiguration.js';
import { TStoreContext } from '../../../models/index.js';
import { AppStore } from '../../App/stores/AppStore.js';
import { ICardConfiguration } from '../models';
type ICardProps = components.base.Card.models.ICardProps;

const UnstyledCard = components.base.Card.UnstyledCard;

export class CardStore extends stores.base.StoreBase<IConfiguration, IComponentStyles> {
	static componentKey = 'card' as const;

	@observable.ref props: ICardProps | undefined;

	constructor(storeContext: TStoreContext, manifest: IManifest) {
		super(storeContext, manifest);
		makeObservable(this);
	}

	@computed
	get configuration(): ICardConfiguration | undefined {
		const appStore = this.storeContext.get<AppStore>('appStore');
		if (appStore) {
			return appStore.getComponentConfiguration(CardStore.componentKey);
		}
	}

	@action
	async initialize(callbacks?: Record<string, EventListener>): Promise<void> {
		const appStore = this.storeContext.get<AppStore>('appStore');
		const appKey = appStore && appStore.appKey;
		const appCardProps = appStore && appStore.appCardProps;
		const props = this.mergeQueriesAndProps<ICardProps | undefined>(this.configuration) || appCardProps;
		if (props) {
			if (appStore && appStore.splitTableOptions) {
				const { hideCardHeader } = appStore.splitTableOptions;
				if (hideCardHeader) {
					props.title = undefined;
					props.subtitle = undefined;
				}
			}
			this.props = props;
			const queryStore = this.storeContext.get<stores.QueryStore<IConfiguration, IComponentStyles>>('queryStore');
			UnstyledCard.loadSuperscripts(appKey, queryStore, props);
		}
	}
}
